// Module
var code = `<simple-table
    get-table-data="retention.notification_request_table_data"
    caption-text="Кол-во игроков, вернувшихся в игру после постройки базы"
    caption-url="https://confluencen.amt-games.com/pages/viewpage.action?pageId=51644215"
>
</simple-table>
`;
// Exports
module.exports = code;